import type { AssetSeason, AssetType } from './types.js';

export const SEASON_MEMBERS: Readonly<Record<Exclude<AssetSeason, 'all'>, readonly AssetType[]>> = {
  winter: [
    'snowPine',
    'snowDeciduous',
    'snowman',
    'snowdrift',
    'igloo',
    'frozenPond',
    'icicle',
    'sled',
    'snowCoveredRock',
    'bareBush',
    'winterBird',
    'firewood',
    'houseWinter',
    'houseBWinter',
    'barnWinter',
    'churchWinter',
    'christmasTree',
    'winterLantern',
    'frozenFountain',
  ],
  spring: [
    'cherryBlossom',
    'cherryBlossomSmall',
    'cherryPetals',
    'tulip',
    'tulipField',
    'sprout',
    'nest',
    'lamb',
    'crocus',
    'rainPuddle',
    'birdhouse',
    'gardenBed',
    'cherryBlossomFull',
    'cherryBlossomBranch',
    'peachBlossom',
    'flowerBed',
    'wateringCan',
    'seedling',
    'robinBird',
    'butterflyGarden',
    'umbrella',
  ],
  summer: [
    'parasol',
    'beachTowel',
    'sandcastleSummer',
    'surfboard',
    'iceCreamCart',
    'hammock',
    'sunflower',
    'watermelon',
    'sprinkler',
    'lemonade',
    'fireflies',
    'swimmingPool',
  ],
  autumn: [
    'autumnMaple',
    'autumnOak',
    'autumnBirch',
    'autumnGinkgo',
    'fallenLeaves',
    'leafSwirl',
    'acorn',
    'cornStalk',
    'scarecrowAutumn',
    'harvestBasket',
    'hotDrink',
    'autumnWreath',
    'pumpkinPatch',
    'hayMaze',
    'appleBasket',
    'rake',
  ],
};
